const $inject = ['$q', '$http', '$rootScope'];

const dataService = function ($q, $http, $rootScope) {
  let service = {
    data: {
      activeItem: undefined,
      items: []
    },
    addNewMode: false,
    addNewBackup: undefined,
    cleanDataOnRouteChange: false,
    refreshDataOnLoad: false,
    searchApi,
    get,
    post,
    spiltDataAt
  };

  let currentSearchDefer = null;
  service.cancelSearch = function cancelSearch() {
    currentSearchDefer && currentSearchDefer.resolve();
  }

  service.search = function search(args = {
    endpoint: undefined,
    searchTerm: undefined,
    searchType: undefined,
    expression: undefined,
    includeDeleted: true,
    selectFields: '',
    limit: undefined,
    sort: undefined,
    filters: undefined,
  }) {

    let { endpoint, searchTerm, searchType, expression, includeDeleted, selectFields, limit, sort, filters } = args;

    currentSearchDefer = $q.defer();
    let type = searchType || 'Id';
    let qs = `${endPointUrl}/odata/${endpoint}`;
    expression = expression || 'eq';
    let hasConditions = false;

    if (selectFields) {
      hasConditions = true;
      qs += `?$select=${selectFields}`;
    }

    if (filters) {
      if (expression === 'contains') {
        expression = ''; 
        filters.forEach((filter, i) => {
          let searchTermToLower = filter.value.toLowerCase().trim();
          expression += `${i > 0 ? ' and ' : ''}contains(tolower(${filter.key}), '${searchTermToLower}')`;
        })
      }
      else if (expression === 'exact') {
        expression = ''; 
        filters.forEach((filter, i) => {
          expression += `${i > 0 ? ' and ' : ''}contains(${filter.key}, '${filter.value}')`;
        })
      }
    } else {
      if (expression === 'contains') {
        let searchTermToLower = searchTerm.toLowerCase().trim();
        expression = `contains(tolower(${type}), '${searchTermToLower}')`;
      }
      else if (expression === 'exact') {
        expression = `contains(${type}, '${searchTerm}')`;
      } else {
        expression = `${type} eq '${searchTerm}'`;
      }
    }

    if (searchTerm || filters) {
      if (!hasConditions) {
        qs += `?`;
      } else {
        qs += `&`;
      }
      hasConditions = true;
      qs += `$filter=${expression}`;
    }

    if (!includeDeleted) {
      if (!hasConditions) {
        qs += `?`;
      }
      if (qs.indexOf('$filter') === -1) {
        qs += `$filter=&IsDeleted ne true`;
      } else {
        qs += ` and IsDeleted ne true`;
      }
    }

    if (limit) {
      qs += `&$top=${limit}`;
    }

    if(sort) {
      qs += `&$orderby=${sort}`;
    }

    $http.get(qs, {timeout: currentSearchDefer.promise})
      .then(function (res) {
        let data = res.data;
        let responseData = data.value || data;
        currentSearchDefer.resolve(responseData);
      })

      .catch(function (err) {
        currentSearchDefer.reject(err);
      });

    return currentSearchDefer.promise;
  };

  function searchApi(apiVersion, endpoint, queryString) {
    $rootScope.$broadcast('lbaLoader:loaderState', {state: 'loading'});

    let deferred = $q.defer();
    const qs = queryString ? `${endPointUrl}/api/${apiVersion}/${endpoint}?${queryString}` : `${endPointUrl}/api/${apiVersion}/${endpoint}`;
       
    $http.get(qs)
      .then(function (res) {        
        $rootScope.$broadcast('lbaLoader:loaderState', {state: 'loaded'});

        let data = res.data;        
        deferred.resolve(data);
      })
      .catch(function (err) {
        $rootScope.$broadcast('lbaLoader:loaderState', { state: 'error' });
        
        deferred.reject(err);
      });

    return deferred.promise;
  };

  function get(query, id, odataQueryOptions = '') {
    $rootScope.$broadcast('lbaLoader:loaderState', {state: 'loading'});

    let deferred = $q.defer();
    const url = id ? `${endPointUrl}/odata/${query}('${id}')${odataQueryOptions}` : `${endPointUrl}/odata/${query}`;

    $http.get(url)
      .then(function (res) {
        const {headers, data} = res;
        const ETag = headers('ETag');
        if (ETag) {
          sessionStorage.setItem('ETag', ETag);
        }
        $rootScope.$broadcast('lbaLoader:loaderState', {state: 'loaded'});

        let responseData = data.value || data;
        deferred.resolve(responseData);
      })
      .catch(function (err) {
        deferred.reject(err);
      });

    return deferred.promise;
  }


  function post(query, data, noETag) {
    let deferred = $q.defer();
    const url = `${endPointUrl}/odata/${query}`;
    const settings = {};
    if (!noETag) {
      settings.headers = {
        'If-Match': sessionStorage.getItem('ETag')
      };
    }

    $rootScope.$broadcast('lbaLoader:loaderState', { state: 'saving' });

    $http.post(url, data, settings)
      .then(function (res) {
        const {headers, data} = res;
        const ETag = headers('ETag');
        if (ETag) {
          sessionStorage.setItem('ETag', ETag);
        }

        $rootScope.$broadcast('lbaLoader:loaderState', { state: 'saved' });
      
        deferred.resolve(data);
      })
      .catch(function (err) {
        const {status} = err;
        if (status === 412) {
          $rootScope.$broadcast('lbaLoader:loaderState', { state: 'expired' });
        } else {
          $rootScope.$broadcast('lbaLoader:loaderState', { state: 'error' });
        }

        deferred.reject();
      });

    return deferred.promise;
  };

  service.delete = function deleteId(resource, id) {
    let deferred = $q.defer();

    $http.delete(`${endPointUrl}/odata/${resource}('${id}')`)
      .then(res => {
        deferred.resolve(res.data);
      })
      .catch(err => {
        $rootScope.$broadcast('lbaLoader:loaderState', { state: 'error' });
        deferred.reject(err.data);
      });


    return deferred.promise;
  };

  service.patch = function patchResource(resource, data, id) {
    let deferred = $q.defer();

    $http.patch(`${endPointUrl}/odata/${resource}('${id}')`, data)
      .then(res => {
        deferred.resolve(res.data);
      })
      .catch(err => {
        deferred.reject(err.data);
      });


    return deferred.promise;
  };

  function spiltDataAt(dataAt, routeParams) {
    return dataAt.split('.').map(x => {
      if (x.startsWith('$')) {
        x = routeParams[x.substring(1)];
      }
      return x;
    });
  }

  return service;
};

dataService.$inject = $inject;

export default dataService;


// WEBPACK FOOTER //
// ./src/services/dataService.js